var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var Card = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-sizing: border-box;\n  border: 1px solid ", ";\n  border-radius: ", ";\n  background-color: #ffffff;\n  box-shadow: 0 2px 14px 0 rgba(29, 114, 104, 0.13);\n  overflow: hidden;\n"], ["\n  box-sizing: border-box;\n  border: 1px solid ", ";\n  border-radius: ", ";\n  background-color: #ffffff;\n  box-shadow: 0 2px 14px 0 rgba(29, 114, 104, 0.13);\n  overflow: hidden;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.lightBg2;
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.radius;
});
var templateObject_1;
//# sourceMappingURL=Card.js.map